import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Form, Tabs, Modal } from 'antd'
import _ from 'lodash'
// import Map from '../Map'
import List from '../List'
import Title from '../Title'
import DispatchEdit from '../../forms/DispatchEdit'
import DispatchStatus from '../DispatchStatus'
import { request } from '../../utils/http'
import { valueTypeAdapter } from '../../utils/models'
import custom from '../../config/custom'
import { setDispatch } from '../../modules/dispatch'
import { FormattedMessage } from 'react-intl'
import AutoInput from '../AutoInput'
import Schedule from '../../forms/Schedule'

import './index.css'

const TabPane = Tabs.TabPane

class DispatchDetail extends Component {

  constructor(props) {
    super(props)

    this.state = {
      visible: true,
      printing: false
    }
  }

  componentDidMount() {
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
  }

  handleSubmit() {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        request(`${custom.baseUrl}/dispatch`, {
          method: 'POST',
          data: valueTypeAdapter(values)
        })
          .then(() => {
            this.hide()
          })
          .catch(() => {
            //
          })
      }
    })
  }

  hide() {
    this.setState({ visible: false }, () => {
      setTimeout(() => {
        this.props.setDispatch(null)
      }, 200)
    })
  }

  printing() {
    window.open(`${custom.baseUrl}/dispatch/${this.props.id}/pdf`)
  }

  render() {
    const canEdit = _.find(this.props.permissions, p => p.name === 'Editar')
    const canClose = _.find(this.props.permissions, p => p.name === 'Cerrar')
    const dispatch = _.find(this.props.items, { id: this.props.selected })
    const disabled = canClose ? dispatch.closedAt : (dispatch.finishedAt || dispatch.canceledAt || !canEdit)

    if (!dispatch) {
      return null
    }

    const belongsToProp = {
      belongsTo: {
        association: 'dispatch',
        id: dispatch.id,
        dispatch 
      },
      showAdd: true
    }

    return (
      <Modal
        title={<Title model="dispatch" value={dispatch} />}
        visible={this.state.visible}
        footer={canEdit && !dispatch.canceledAt ? <DispatchStatus id={this.props.id} /> : null}
        width={800}
        onCancel={() => { this.hide() }}
      >
        <div style={{ marginTop: -25 }}>
          <Tabs defaultActiveKey="details">
            <TabPane tab={<FormattedMessage id={'Detail.title'} />} key="details">
              <Form onSubmit={this.handleSubmit} style={{ width: '100%' }}>
                <DispatchEdit disabled={disabled} form={this.props.form} model="dispatch" id={dispatch.id} />
              </Form>
            </TabPane>
            <TabPane tab={<FormattedMessage id={'Attribute.dispatch.files'} />} key="files">
              <Form onSubmit={this.handleSubmit} style={{ width: '100%' }}>
                <AutoInput
                  autoSave
                  form={this.props.form}
                  model={'dispatch'}
                  id={dispatch.id}
                  attribute={'files'}
                  multiple={true}
                  accept={'*'}
                />
              </Form>
            </TabPane>
            <TabPane tab={<FormattedMessage id={'Attribute.dispatch.items'} />} key="items">
              <List disabled={disabled} model="item" {...belongsToProp} />
            </TabPane>
            <TabPane tab={<FormattedMessage id={'Attribute.dispatch.references'} />} key="references">
              <List disabled={disabled} model="reference" customerId={dispatch.customer.id} {...belongsToProp} />
            </TabPane>
            <TabPane tab={<FormattedMessage id={'Attribute.dispatch.schedule'} />} key="schedule">
              <Schedule disabled={disabled} form={this.props.form} model={'dispatch'} id={this.props.id} />
            </TabPane>
            <TabPane tab={<FormattedMessage id={'Attribute.dispatch.charges'} />} key="charges">
              <List disabled={disabled} model="charge" {...belongsToProp} />
            </TabPane>
            <TabPane tab={<FormattedMessage id={'Attribute.dispatch.stopOvers'} />} key="stopOvers">
              <List disabled={disabled} model="stopover" {...belongsToProp} />
            </TabPane>
          </Tabs>
        </div>
      </Modal>
    )
  }

}

const mapStateToProps = state => ({
  items: state.dispatch.items,
  selected: state.dispatch.selected,
  permissions: state.auth.permissions
})

const mapDispatchToProps = dispatch => bindActionCreators({
  setDispatch
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(DispatchDetail))



// WEBPACK FOOTER //
// ./src/containers/DispatchDetail/index.js